import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.167 14.167H5.833c-1.152 0-2.135-.406-2.948-1.218-.812-.813-1.218-1.796-1.218-2.948 0-1.153.406-2.136 1.218-2.948.813-.813 1.796-1.219 2.948-1.219h3.334v1.667H5.833a2.41 2.41 0 0 0-1.77.729 2.41 2.41 0 0 0-.73 1.77c0 .695.243 1.285.73 1.771.486.487 1.076.73 1.77.73h3.334v1.666Zm-2.5-3.333V9.167h6.666v1.667H6.667Zm4.166 3.333v-1.666h3.334c.694 0 1.284-.243 1.77-.73a2.41 2.41 0 0 0 .73-1.77 2.41 2.41 0 0 0-.73-1.771 2.411 2.411 0 0 0-1.77-.73h-3.334V5.835h3.334c1.152 0 2.135.406 2.948 1.219.812.812 1.218 1.795 1.218 2.948 0 1.152-.406 2.135-1.218 2.948-.813.812-1.795 1.218-2.948 1.218h-3.334Z"
    }, null, -1)
  ])))
}
export default { render: render }